exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-share-list li{display:inline-block;margin:0 .75rem 0 0}", ""]);

// exports
exports.locals = {
	"ds-share-list": "ds-share-list"
};